import React from "react";
import DateFormater from "../../../Utils/DateFormater.utils";

const NewEventCard = ({ data }) => {
  return (
    <div className="p-1 w-full h-fit flex-col align-start justify-start g-2 radius-6 back-white">
      <span className="w-full text-align-center poppins color-grayColor">
        New event created
      </span>

      <div className="flex-col align-start justify-start g-1">
        <div className="flex-row align-start justify-start g-05">
          <span className="poppins t-14 color-black">Time:</span>
          <span className="poppins t-14 color-grayColor">
            {data?.timestamp}
          </span>
        </div>
        <hr color="#DCDBDB" className="w-full" />
      </div>

      <div className="flex-col align-start justify-start g-05">
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Event name:</span>
          <span className="poppins t-14 color-grayColor">
            {data?.details?.eventName}
          </span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Subject:</span>
          <span className="poppins t-14 color-grayColor">
            {data?.details?.subject}
          </span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Time:</span>
          <span className="poppins t-14 color-grayColor">
            {data?.details?.time}
          </span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Staring date:</span>
          <span className="poppins t-14 color-grayColor">
            {DateFormater(data?.details?.startDate)}
          </span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Ending date:</span>
          <span className="poppins t-14 color-grayColor">
            {DateFormater(data?.details?.endDate)}
          </span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Venue:</span>
          <span className="poppins t-14 color-tableColor">
            {data?.details?.venue}
          </span>
        </div>
      </div>
    </div>
  );
};

export default NewEventCard;
